__webpack_require__.p = "/sos-bandar-competences/";